var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"absolute","top":"0","left":"0px","width":"100%","height":"100%"},style:({ left: _vm.l.toString() + 'px' }),attrs:{"id":"bounded-image"}},[_c('canvas',{ref:"bounded-canvas"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }